import EditorialModuleArticles from '../src/EditorialModuleArticles.tsx';
export default EditorialModuleArticles;
